import classNames from "classnames";
import React, { AnchorHTMLAttributes } from "react";

import { buttonClassNames, ButtonProps } from "..";

import style from "./AnchorButton.module.scss";

interface AnchorButtonProps
  extends AnchorHTMLAttributes<HTMLAnchorElement>,
    Pick<ButtonProps, "size" | "fixedWidth" | "theme"> {}

const AnchorButton: React.FC<AnchorButtonProps> = ({
  size,
  theme,
  fixedWidth,
  className,
  children,
  ...anchorProps
}) => (
  <a
    target="_blank"
    rel="noopener noreferrer"
    {...anchorProps}
    className={classNames(buttonClassNames({ size, theme, fixedWidth }), style.link, className)}
  >
    {children}
  </a>
);

export default AnchorButton;
